import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import { useTranslation } from "react-i18next";

const useAxiosTryPrivate = () => {
  const refresh = useRefreshToken();
  const { auth } = useAuth();
  const { i18n } = useTranslation();

  useEffect(() => {
    const isAuthEmpty = Object.keys(auth).length === 0;
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config) => {
        if (!isAuthEmpty && !config.headers["Authorization"]) {
          config.headers["Authorization"] = `Bearer ${auth?.token}`;
        }
        if (i18n.language) {
          config.headers["Accept-Language"] = i18n.language;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;
        if (error?.response?.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true;
          if (!isAuthEmpty) {
            try {
              const newAccessToken = await refresh();
              prevRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
              return axiosPrivate(prevRequest);
            } catch (e) {
              // Remove token from local storage
              console.log("Remove token from local storage");
              localStorage.removeItem("auth");
            }
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [auth, refresh]);

  return axiosPrivate;
};

export default useAxiosTryPrivate;
